$ = require 'jquery'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/power_ups_card_aging_prefs'

module.exports = class CardAgingSettingsView extends View
  viewTitleKey: 'card aging settings'

  initialize: ->
    @listenTo @model,
      'change:prefs': @render

  events:
    'click .js-select:not(.disabled)': 'selectMode'

  render: ->
    @$el.html(template(
      agingMode: @model.getPref('cardAging')
      canChange: @model.editable()
    ))

    @

  selectMode: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-select')

    setting = $target.attr('name')
    @model.setPref('cardAging', setting)
